var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var ECapPadGeneratorInteractionModel = require('../e-cap/eCapPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var CrystalPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    ECapPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(CrystalPadGeneratorInteractionModel, ECapPadGeneratorInteractionModel);
CrystalPadGeneratorInteractionModel.$class = 'CrystalPadGeneratorInteractionModel';

module.exports = CrystalPadGeneratorInteractionModel;

CrystalPadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    ECapPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.optionalCustomDimension = this.shadow("optionalCustomDimension",
        function() {
            return self.data.optionalCustomDimension();
        },
        function(value) {
            return self.data.optionalCustomDimension(value);
        },
        [self.data.optionalCustomDimension]
    );

    this.showOptionalCustomParamg = this.shadow("showOptionalCustomParamg",
        function() {
            return (self.data.hasCustomFootprint() && this.data.optionalCustomDimension() === cio_datamodel.IpcDataModel.ComponentAttribute.optionalCustomDimensionInput["Optional_g"] );
        },
        null,
        [
            self.data.optionalCustomDimension, self.data.hasCustomFootprint
        ]
    );

    this.showOptionalCustomParamp = this.shadow("showOptionalCustomParamp",
        function() {
            return (self.data.hasCustomFootprint() && this.data.optionalCustomDimension() === cio_datamodel.IpcDataModel.ComponentAttribute.optionalCustomDimensionInput["Optional_p"] );
        },
        null,
        [
            self.data.optionalCustomDimension, self.data.hasCustomFootprint
        ]
    );
};
CrystalPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

CrystalPadGeneratorInteractionModel.prototype.getInspectorElementForOptionalCustomParam = function() {
    var optionalCustomDimensionList = [];

    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.optionalCustomDimensionInput) {
        var c = cio_datamodel.IpcDataModel.ComponentAttribute.optionalCustomDimensionInput[t];
        optionalCustomDimensionList.push([this.LCLZ(t, c), c]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('optionalDimension', 'Optional Dimension'), this.optionalCustomDimension, optionalCustomDimensionList, this.hasCustomFootprint)];
};

CrystalPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //optional custom param 
    if (this.withCustomFootprintParams() && this.showFootprintParams()){
        this.getInspectorElementForPadGapInCustomFootprint = function() {
            return [PackageGeneratorInspectorConfig.getValueFixedUnit('g', this.LCLZ('customPadGap', 'Custom Pad To Pad Gap'), this.customPadToPadGap, this.userSettingsModel.distanceUnit, this.showOptionalCustomParamg)];
        };

        this.getInspectorElementForPadPitchInCustomFootprint = function() {
            return [PackageGeneratorInspectorConfig.getValueFixedUnit('p', this.LCLZ('customPadPitch', 'Custom Pad Pitch'), this.customPadPitch, this.userSettingsModel.distanceUnit, this.showOptionalCustomParamp)];
        };
    }

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintCrystal));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForOptionalCustomParam());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForPadPitchInCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForLabel(this.LCLZ('crystalNote', '* Select optional dimension from (D, D2, L). Different combinations may produce different footprint pad sizes.')));
    imElements = imElements.concat(this.getInspectorElementForOptionalDiamension());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalGap());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};